/**
 * Magic strings, must be kept in sync with App\Support\Magic.php
 */

const strings = {
  // Registration
  preRegistration: 'Pre Registration',
  registrationApproval: 'Registration Approval',
  experienceApproval: 'Experience Approval',
  moduleApproval: 'Module Approval',
  postRegistration: 'Post Registration',
  finalApproval: 'Final Approval',
  complete: 'Complete',
  moduleStepPrefix: 'module_',
  pathwayApprovalStep: 'pathway_summary',
  preferencesStep: 'preferences',
  examStep: 'take_exam',
  educationStep: 'education', // This doesn't exist on purpose
  experienceStep: 'experience',
  ethicsStep: 'code_of_ethics',
  reviewStep: 'final_summary',
  preRegistrationSteps: [
    'pathway',
    'modules',
    'university',
    'documentation',
    'pathway_summary',
    'course_materials',
    'shipping',
    'membership',
    'donation',
    'summary',
  ],
  postRegistrationSteps: [
    'module_1',
    'module_2',
    'module_3',
    'take_exam',
    'experience',
    'employment_verification',
    'certificate_name',
    'professional_info',
    'preferences',
    'code_of_ethics',
    'final_summary',
  ],

  // Certification
  certificateGoodStanding: 'In Good Standing',
  certificateLapsedCEUs: 'Lapsed (CEU)',
  certificateLapsedPayment: 'Lapsed (Payment)',
  certificateRevoked: 'Revoked',
  certificateRenewed: 'Renewed',

  // Credits
  pendingCredit: 'Pending',
  rejectedCredit: 'Rejected',
  needsVerificationCredit: 'Needs Verification',
  approvedCredit: 'Approved',

  // Pathways
  selfStudyPathway: 'self_study',
  educationPathway: 'educational_challenge',
  designationPathway: 'designation_challenge',
  universityPathway: 'university_program',
  ffcPathway: 'ffc',
  legacyFFCPathwayIds: [6, 7],

  // Files
  nonProfitStatus: 'non_profit_status',
  mme: 'money_management_essentials',
  coursework: 'coursework',
  designation: 'designation',
  studentExam: 'student_exam',
  studentMembership: 'student_membership',
  resume: 'resume',
  clientLetter: 'client_letter',
  peerLetter: 'peer_letter',
  supervisorLetter: 'supervisor_letter',
  employmentVerification: 'employment_verification',
  programAgenda: 'program_agenda',
  creditCompletion: 'credit_completion',
  educationalChallenge: 'educational_challenge',
  supportingDocumentation: 'supporting_documentation',

  // Roles
  adminRole: 'Administrator',

  // Announcments
  membershipAnnouncement: 'membership',
  symposiumAnnouncement: 'symposium',
  trainingAnnouncement: 'training',

  // Profile Completeness
  profileFields: [
    'dateOfBirth',
    'gender',
    'ethnicity',
    'website',
    'contactMethod',
    'homePhone',
    'workPhone',
    'organization',
    'jobTitle',
    'yearsOfService',
    'mentorConnect',
    'bio',
    'twitterHandle',
    'instagramProfile',
    'linkedinProfile',
  ],

  // Expiration Statuses
  notExpired: 'not expired',
  expiredWithoutExtension: 'expired w/o extension',
  expired: 'expired',

  // Event Types
  eventWebinar: 'webinar',
  eventOnsite: 'onsite',
  eventFpa: 'fpa',
  eventVirtual: 'virtual_member_meet_up',

  // Email Dropdowns
  emailRegistrationApproval: 'registration_approval',
  emailRegistrationRejection: 'registration_rejection',
  emailCertificationRejection: 'certification_rejection',
  emailCEURejection: 'ceu_rejection',
  emailExperienceApproval: 'experience_approval',
  emailExperienceRejection: 'experience_rejection',
  emailMembershipRejection: 'membership_rejection',
  emailGroupCEUApproval: 'group_ceu_approval',
  emailGroupCEURejection: 'group_ceu_rejection',

  // Admin
  adminOverrideToken: 'admin_override',
};

const composites = {
  approvalStatuses: [strings.registrationApproval, strings.finalApproval],
  preRegistrationStatuses: [strings.preRegistration, strings.registrationApproval],
  postRegistrationStatuses: [
    strings.moduleApproval,
    strings.experienceApproval,
    strings.postRegistration,
    strings.finalApproval,
    strings.complete,
  ],
  creditStatuses: [
    strings.pendingCredit,
    strings.rejectedCredit,
    strings.needsVerificationCredit,
    strings.approvedCredit,
  ],
  events: {
    [strings.eventWebinar]: 'Webinar',
    [strings.eventOnsite]: 'On-Site Training',
    [strings.eventFpa]: 'FPA Connect',
    [strings.eventVirtual]: 'Virtual Member Meet Up',
  },
};

export default {
  ...strings,
  ...composites,
};
